// Character limits of the Policy Life Cycle text boxes, mirroring the [MaxLength] on the backend request
// DTOs (PolicyDocumentDto.cs) and the custom-upload columns. A box over its limit is refused before the
// request with a message naming the field, instead of the server's 400 surfacing as "Could not …".
export const POLICY_TEXT_LIMITS = {
    lifecycleNote: 1000,
    decisionComment: 2000,
    exceptionTitle: 300,
    exceptionJustification: 2000,
    exceptionCompensatingControls: 2000,
    exceptionAffectedObject: 300,
    exceptionDecisionReason: 1000,
    mappingReference: 200,
    mappingDescription: 1000,
    requirementText: 500,
    requirementObjectScope: 300,
    requirementRemediation: 1000,
    evidenceTitle: 200,
    evidenceValue: 2000,
    evidenceDescription: 500,
    policyTitle: 300,
    policyDescription: 1000,
};

export const formatCount = (n) => n.toLocaleString("en-US");

/** "<label> must be N characters or fewer (currently M)." when the text is over the limit, else null. */
export const tooLongMessage = (label, value, max) => {
    const length = (value || "").length;
    return length > max ? `${label} must be ${formatCount(max)} characters or fewer (currently ${formatCount(length)}).` : null;
};

/** The first over-limit message among [label, value, max] checks, or null. */
export const firstTooLong = (checks) => {
    for (const [label, value, max] of checks) {
        const message = tooLongMessage(label, value, max);
        if (message) return message;
    }
    return null;
};

/**
 * The message to show for a failed request: the API's own `message`, else the first ASP.NET model
 * validation error (a 400 with { errors: { Field: [message] } } and no `message`), else the fallback.
 */
export const apiErrorMessage = (error, fallback) => {
    const data = error?.response?.data;
    if (typeof data?.message === "string" && data.message.trim()) return data.message;
    const validation = Object.values(data?.errors || {}).flat().find(m => typeof m === "string" && m.trim());
    return validation || fallback;
};
